<template>
  <slotted-edit-list-item :label="label"
                          :value="value"
                          :edit="edit"
                          :noempty="noempty"
                          :overrideDisplayValue="litext">

    <template v-slot:normalmodecontent
              v-if="multiple">
      <normal-mode-template :label="label"
                            :value="editValue">
        <template v-slot:value>
          <div class="valuetext pl-3 pb-2">
            <v-chip v-for="item in value"
                    :key="item.Id"
                    color="#f1f1f1"
                    small
                    class="ml-0 mr-1 my-1 elevation-1">
              <span>{{ item.Description }}</span>
            </v-chip>
          </div>
        </template>
      </normal-mode-template>
    </template>

    <template v-slot:editmodecontent>
      <v-list-item-content class="pb-0 pt-3">
        <v-autocomplete v-model="editValue"
                        :rules="rule"
                        :label="noempty ? label + '*' : label"
                        :items="list"
                        :item-text="textkey ? textkey : null"
                        :item-value="valuekey ? valuekey : null"
                        outlined
                        dense
                        :multiple="multiple"
                        :clearable="!noempty"
                        hide-details="auto"
                        :menu-props="{ bottom: true, offsetY: true }">
          <template v-slot:selection="{ item }"
                    v-if="multiple">
            <div class="mt-2 mb-0">
              <v-chip close
                      @click:close="remove(valuekey ? item[valuekey] : item)"
                      close-icon="mdi-close"
                      color="primary"
                      small
                      class="ml-0 mr-1">
                <span>{{ textkey ? item[textkey] : item }}</span>
              </v-chip>
            </div>
          </template>
        </v-autocomplete>
      </v-list-item-content>
    </template>

  </slotted-edit-list-item>
</template>


<script>
import rules from "@/helpers/Mixins/RuleMixin.js";
import SlottedEditListItem from "@/components/Inputs/Parts/SlottedEditListItem.vue";
import NormalModeTemplate from "@/components/Inputs/Parts/NormalModeTemplate.vue";

export default {
  name: "SelectListItem",
  props: ["label", "keyname", "value", "multiple", "defaultindex", "list", "valuekey", "textkey", "edit", "noempty"],
  components: { SlottedEditListItem, NormalModeTemplate },
  mixins: [rules],

  data() {
    return { editValue: null };
  },

  mounted() {
    this.parseInputValue();
    this.emitValue();
  },

  methods: {
    /*
    onChange(value) {
      this.$emit("input", value);
    },
    */
    emitValue() {
      this.$emit("fetch", { key: this.keyname, value: this.editValue });
      //this.$emit("input", this.editValue);
    },

    parseInputValue() {
      var parsed = this.parseInput();
      //this.editValue = ;
      //this.$emit("input", parsed && this.valuekey ? parsed[this.valuekey] : parsed);
      this.editValue = parsed && this.valuekey && !this.multiple ? parsed[this.valuekey] : parsed;
    },

    parseInputText() {
      var parsed = this.parseInput();
      return parsed && this.textkey ? parsed[this.textkey] : parsed;
    },

    parseInput() {
      if (!this.multiple) {
        const defIndex = this.isValidId(this.defaultindex) ? this.defaultindex : 0;
        if (this.value != undefined && this.value != null && typeof this.value != "object") {
          //if value is not and object (like if sending in id instead of {id:x})
          var index = this.list.findIndex((x) => x[this.valuekey] === this.value);
          if (index > -1) {
            //if could fin object corresponding to value return it
            return this.list[index];
          } else {

            //else was not found so return default or null
            return this.noempty ? this.list[defIndex] : null;
          }
        } else if (this.value) {
          //if object return it
          return this.value;
        } else {
          if (this.noempty) {
            //if have to send something back send default indexed item
            return this.list[defIndex];
          } else {
            return null;
          }
        }
      } else {
        return this.value;
      }
    },

    remove(obj) {
      let index = this.value.indexOf(obj);
      this.value = this.value.splice(index, 1);
    },
  },

  computed: {
    rule() {
      if (this.noempty) {
        return this.noEmptyRule;
      } else {
        return [];
      }
    },

    litext() {
      return this.parseInputText();
    },
  },

  watch: {
    //Set initial value
    value: {
      deep: true,
      handler() {
        this.parseInputValue();
      },
    },
    //Emits edited value on change
    editValue: {
      deep: true,
      handler() {
        this.emitValue();
      },
    },
  },
};
</script>

<style scoped>
.v-list {
  padding: 0;
}
</style>

<style>
.theme--light.v-list-item .v-list-item__mask {
  color: rgb(255, 255, 255) !important;
  background: #0112f7 !important;
  padding: 0 1px;
  margin: 0 1px;
}
</style>